import React, { useEffect, useRef } from 'react';

interface HistogramDisplayProps {
  imageData: string;
  title: string;
}

const HistogramDisplay: React.FC<HistogramDisplayProps> = ({ imageData, title }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (imageData && canvasRef.current) {
      drawHistogram();
    }
  }, [imageData]);

  const drawHistogram = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const img = new Image();
    img.onload = () => {
      const tempCanvas = document.createElement('canvas');
      const tempCtx = tempCanvas.getContext('2d');
      if (!tempCtx) return;

      tempCanvas.width = img.width;
      tempCanvas.height = img.height;
      tempCtx.drawImage(img, 0, 0);

      const imageData = tempCtx.getImageData(0, 0, img.width, img.height);
      const data = imageData.data;

      // Calculate histogram
      const histogram = new Array(256).fill(0);
      for (let i = 0; i < data.length; i += 4) {
        // Convert to grayscale for histogram
        const gray = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]);
        histogram[gray]++;
      }

      // Draw histogram
      canvas.width = 256;
      canvas.height = 100;
      ctx.fillStyle = '#f0f0f0';
      ctx.fillRect(0, 0, 256, 100);

      const maxValue = Math.max(...histogram);
      ctx.fillStyle = '#007bff';

      for (let i = 0; i < 256; i++) {
        const barHeight = (histogram[i] / maxValue) * 90;
        ctx.fillRect(i, 100 - barHeight, 1, barHeight);
      }
    };
    img.src = imageData;
  };

  return (
    <div style={{ textAlign: 'center', margin: '10px 0' }}>
      <h5>{title} Histogram</h5>
      <canvas
        ref={canvasRef}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          maxWidth: '100%'
        }}
      />
    </div>
  );
};

export default HistogramDisplay;